window.addEventListener("load", () => {
	const map = document.querySelector(".gm-style");
	const observer = new MutationObserver(() => {
		const phoneElement = map.querySelector(".gm_popup .phone");
		if (phoneElement) {
			phoneElement.addEventListener("click", () => {
				window.location.href = `tel:${phoneElement.textContent.trim()}`;
			});
		}
	});
	observer.observe(map, { childList: true, subtree: true });

	const mapContainer = document.querySelector(".show-addresses");
	const mapContainerObserver = new MutationObserver(() => {
		if (!mapContainer.firstElementChild.classList.contains("map-legend")) {
			mapContainerObserver.disconnect();
			const mapLegend = document.createElement("div");
			mapLegend.className = "map-legend";
			mapLegend.innerHTML = `
				<div><span></span>Sherwin Williams</div>
				<div><span></span>Independent Retailer</div>
			`;
			mapContainer.prepend(mapLegend);
			mapContainerObserver.observe(map, { childList: true, subtree: true });
		}
	});
	mapContainerObserver.observe(map, { childList: true, subtree: true });
});

document.addEventListener('DOMContentLoaded', function () {
	// MAIN FUNCTION
	function handlePopupChanges(mutationsList, observer) {
		mutationsList.forEach(function (mutation) {
			if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
				mutation.addedNodes.forEach(function (addedNode) {
					if (addedNode.nodeType === 1) { // we ensure it's an element node
						var storeWebsiteElement = addedNode.querySelector('.name');
						if (storeWebsiteElement) {
							// Check if links are already appended
							if (!storeWebsiteElement.dataset.linkProcessed) {
								var parentElement = storeWebsiteElement.parentElement;

								var popupText = storeWebsiteElement.textContent.trim();
								// Create links for Google Maps and Directions
								var googleMapsLink = 'https://www.google.com/maps/search/?api=1&query=' + encodeURIComponent(popupText);
								var directionsLink = 'https://www.google.com/maps/dir/?api=1&destination=' + encodeURIComponent(popupText);

								// Create "View on Google" link
								var googleLink = document.createElement('a');
								googleLink.className = "google-link";
								googleLink.href = googleMapsLink;
								googleLink.target = "_blank";
								googleLink.textContent = "View on Google Maps";
								googleLink.style.display = "block";
								googleLink.style.marginTop = "20px";


								// Create "Get Directions" link
								var directionsLinkElem = document.createElement('a');
								googleLink.className = "directions-link";
								directionsLinkElem.href = directionsLink;
								directionsLinkElem.target = "_blank";
								directionsLinkElem.textContent = "Get Directions";
								directionsLinkElem.style.display = "block";
								directionsLinkElem.style.marginTop = "10px";

								// Append links to the parent element of .name
								parentElement.appendChild(googleLink);
								parentElement.appendChild(directionsLinkElem);

								// Mark the links as processed to avoid duplicate processing
								storeWebsiteElement.dataset.linkProcessed = true;
							}
						}
					}
				});
			}
		});
	}

	// Create a MutationObserver instance
	var observer = new MutationObserver(handlePopupChanges);
	var config = { childList: true, subtree: true };
	observer.observe(document.body, config);
});